import React, { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import MessageInput from "../../ChatBox/MessageInput/MessageInput";
import MessageText from "../../ChatBox/MessageText";
import "./LiveChat.css";
// import { createChatApi } from "../../../utils/Api";
import { IoChatbubblesSharp } from "react-icons/io5";
import RtmChannelMessageEnum from "../../../utils/Enums/RtmChannelMessage.enum";
import { JudgeDebateReducerEnum } from "../../../utils/enum";
const LiveChat = React.memo(
  ({ debateId, liveChats, agoraServiceRef, dispatch }) => {
    const { data } = useSelector((state) => state.user);
    const inputRef = useRef();
    const scrollRef = useRef();

    //   const { _id } = activeDebate?.current;
    //   try {
    //     const res = await findChatApi(_id);
    //     if (res.status === 200) {
    //       const { message } = res.data;
    //       setLiveMessages(message);
    //     } else {
    //       throw Error(res.data?.message);
    //     }
    //   } catch (error) {
    //     console.log(error);
    //   }
    // };
    const handleSendMessage = async (msgText, cb) => {
      const newChat = {
        owner: data,
        debate: debateId,
        text: msgText,
      };
      dispatch({
        type: JudgeDebateReducerEnum.ADD_LIVE_CHAT,
        payload: newChat,
      });
      sendRtmChannelMessage(newChat);
      if (cb) cb();
    };

    useEffect(() => {
      scrollRef.current.scrollTo(0, scrollRef.current.scrollHeight);
    }, [liveChats]);

    const sendRtmChannelMessage = async (data) => {
      if (!agoraServiceRef.current) return;

      data.type = RtmChannelMessageEnum.SET_LIVE_CHAT;
      agoraServiceRef.current.sendMessageToChannel(data);
      console.log("sending", data);
      if (inputRef.current) {
        inputRef.current.value = "";
      }
      // console.log("sending",rtmChannel.current ,RoomService)
    };

    return (
      <div className="LiveChatWrapper flex-[8]">
        <div className="live_chat_header">
          <IoChatbubblesSharp />
          <h2>LIVE CHATS</h2>
        </div>
        <div ref={scrollRef} className="live_chat_message_list">
          {liveChats &&
            liveChats.map((message) => (
              <div key={message?._id}>
                <MessageText
                  message={message}
                  own={message?.owner?._id === data?._id}
                />
              </div>
            ))}
        </div>
        <MessageInput
          inputRef={inputRef}
          isLiveChat={true}
          handleSendMessage={handleSendMessage}
        />
      </div>
    );
  }
);

export default LiveChat;
